function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(0 0)",
  fill: "#36b37e",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon-2",
  "data-name": "Icon",
  d: "M3.4,7.3.137,4.062a.52.52,0,0,1,0-.7l.723-.7A.435.435,0,0,1,1.2,2.5a.5.5,0,0,1,.361.156L3.75,4.844,8.437.156A.5.5,0,0,1,8.8,0a.435.435,0,0,1,.342.156l.723.7A.476.476,0,0,1,10,1.211a.476.476,0,0,1-.137.352L4.1,7.3a.474.474,0,0,1-.7,0Z",
  transform: "translate(7 8.52)",
  fill: "#36b37e"
}));

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1a469267.svg";
export { ForwardRef as ReactComponent };